export default (element, eventName, data) => {
    if (!element) {
        return;
    }

    element.dispatchEvent(new CustomEvent(eventName, {detail: data}));
};
